export const MIN_FONT_SIZE = 8;
export const MAX_FONT_SIZE = 32;
